import { baseApi } from './baseApi';
import { ServiceTypes } from '../constants';
import { addNotification } from '../store';
import { captureError } from '@clatter/platform';

enum RequestIds {
  GET_STATUS = 'GET_STATUS',
}

const baseUrl = 'ingest-jobs';

export const ingestJobs = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIngestJobStatus: builder.query<IngestJob, { ingestJobId: string | number }>({
      query: ({ ingestJobId }) => ({
        url: `/${baseUrl}/${ingestJobId}`,
        method: 'GET',
      }),
      transformResponse: (result: IApiResponse<IngestJob>) => result.data,
      // validateDataWithJoi({
      //   actionName: 'Service:: getIngestStatus',
      //   data: result.data,
      //   validateJsonSchema: false,
      //   joiSchema: joiSchemaValidators.INGEST_JOB_STATUS_RESPONSE,
      // }),
      providesTags: () => [{ type: ServiceTypes.INGEST_JOBS, id: RequestIds.GET_STATUS }],
    }),
    createIngestJob: builder.mutation({
      query: (body) => {
        return {
          url: `/${baseUrl}`,
          method: 'POST',
          body: body,
        };
      },
    }),
    updateIngestJobUploadCompleted: builder.mutation<any, { ingestJobId: number }>({
      query: ({ ingestJobId }) => ({
        url: `/${baseUrl}/${ingestJobId}`,
        method: 'PATCH',
        body: {
          upload_completed: true,
        },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error: any) {
          const message = 'Failed to mark ingest job upload as completed.';
          dispatch(
            addNotification({
              type: 'error',
              message: message,
            }),
          );
          captureError(error, { message, component: 'ingest.service' });
        }
      },
    }),
  }),
});

export const { useGetIngestJobStatusQuery, useCreateIngestJobMutation, useUpdateIngestJobUploadCompletedMutation } =
  ingestJobs;
